import styled from 'styled-components';

export const FooterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 32px 0;
  @media (max-width: 768px) {
    flex-direction: column-reverse;
  }
`;

export const Copyright = styled.p`
  font-family: 'Gilroy';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  /* identical to box height, or 125% */

  letter-spacing: 0.1px;

  /* Spun Pearl */

  color: #aaabbc;
`;

export const MakedWraper = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 768px) {
  margin-bottom: 10px;
}
`;

export const Maked = styled.p`
  font-family: 'Gilroy';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  letter-spacing: 0.1px;

  /* White */

  color: #ffffff;
  margin-right: 6px;
`;

export const Heart = styled.img`
  display: block;
  width: 20px;
  height: 20px;
`;

export const Mail = styled.a`
  font-family: 'Gilroy';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.1px;
  color: #aaabbc;
  text-decoration: none;
  @media (max-width: 768px) {
  margin-bottom: 10px;
}
`;
